import React from 'react';
import PropTypes from 'prop-types';
import { object, mixed, string } from 'yup';
import { Card, CardFooter, CardBody } from 'reactstrap';
import { Button, Form } from '@cordata/buffet';
import { useHistory } from 'react-router-dom';
import kebabcaseKeys from 'kebabcase-keys';
import { toast } from 'react-toastify';

import { authorizedPyInstance as Py } from '~/utils';

import Fields from './Fields';

const validationSchema = object().shape({
  allergyUid: mixed().nullable().required(),
  medicationUid: mixed().when('allergyUid', {
    is: v => v.allergyName === 'Medication',
    then: s => s.nullable().required(),
    otherwise: s => s.notRequired(),
  }),
  comments: string(),
  patientUid: mixed().required(),
});

const initialValues = {
  allergyUid: '',
  medicationUid: '',
  comments: '',
};

const handleSubmit = (v, b) => {
  const p = [
    'allergyUid',
    'medicationUid',
    'patientUid',
    'comments',
  ].reduce((a, m) => ({
    ...a,
    [m]: m.includes('Uid') ? v[m].id : v[m],
  }), {});

  const method = v.id ? 'put' : 'post';
  const url = `api/data/public/patient-allergy${v.id ? `/${v.id}` : ''}`;

  console.log(method, url, p, v, b);

  return Py[method](url, kebabcaseKeys(p));
};

const AllergyForm = ({ data, disabled }) => {
  const history = useHistory();

  return (
    <Form
      displayName="AllergyForm"
      validationSchema={validationSchema}

      initialValues={{
        ...initialValues,
        ...data,
      }}

      onSubmit={(v, b) =>
      handleSubmit(v, b)
        .then(() => toast.success('Successfully Saved!'))
        .then(() => history.push(`/patients/${v.patientUid.id}/allergies`))
        .catch(e => b.setErrors({ server: e.errors }))
        .finally(() => b.setSubmitting(false))

    }
    >
      {({
        isSubmitting,
      }) => (
        <Card>
          <CardBody className="p-0">
            <Fields disabled={disabled} />
          </CardBody>

          <CardFooter className="d-flex">
            <div className="ml-auto">
              <Button
                type="button"
                color="tertiary"
                outline
                icon="times"
                disabled={isSubmitting}
                onClick={() => history.goBack()}
              >
                Cancel
              </Button>

              <Button type="submit" disabled={disabled || isSubmitting}>
                {isSubmitting ? 'Working ...' : 'Save'}
              </Button>
            </div>
          </CardFooter>
        </Card>
      )}
    </Form>
  );
};

AllergyForm.propTypes = {
  data: PropTypes.shape(),
  disabled: PropTypes.bool,
};

AllergyForm.defaultProps = {
  data: {},
  disabled: false,
};

export default AllergyForm;
